import { DOCUMENT } from "@angular/common";
import { Component, OnInit, Inject, ViewChild, Renderer2 } from "@angular/core";
import {
  ActivatedRoute,
  Router,
  UrlSegment,
  PRIMARY_OUTLET,
  UrlSegmentGroup,
} from "@angular/router";
import { HomepageService } from "../../../services/homepage.service";
import { SearchService } from "../../../services/search.service";
import { RouterExtService } from "../../../services/previous-route.service";
import { CookieService } from "ngx-cookie-service";
import { AuthService } from "../../../services/auth.service";
import { NotifierService } from "angular-notifier";
import { DatepickerOptions } from "ng2-datepicker";
//import { RatingChangeEvent} from "angular-star-rating"

declare var googleApiCall: any;
declare var openLoginModal: any;
declare var getImageWidth: any;

@Component({
  selector: "app-detail",
  templateUrl: "./detail.component.html",
  styleUrls: ["./detail.component.css"],
})
export class DetailComponent implements OnInit {
  @ViewChild("galleryOne") galleryOne;
  @ViewChild("tabModal") tabModal;
  private readonly notifier: NotifierService;
  constructor(
    private authService: AuthService,
    private searchService: SearchService,
    private route: ActivatedRoute,
    private router: Router,
    private homepageService: HomepageService,
    private routerService: RouterExtService,
    private cookieService: CookieService,
    @Inject(DOCUMENT) private document: Document,
    notifierService: NotifierService
  ) {
    this.notifier = notifierService;
    this.route.queryParams.subscribe((params) => {
      if (typeof params.location != "undefined") {
        this.homepageService.setLocationId(params.location);
      }
      this.facets = params.facets;
    });
    this.route.params.subscribe((params) => {
      this.cacheKey = this.route.snapshot.paramMap.get("chacheKey");
      this.listId = this.route.snapshot.paramMap.get("listId");
      this.loadDetail(this.cacheKey, this.listId);
    });
  }
  hasDetailTab: boolean = false;
  link: string = "";
  linkCopied: boolean = false;
  highlightParameter: string = "";
  saveReviewStatus: boolean = false;
  showReviewModal: boolean = false;
  showAddFormStatusHold: boolean = false;
  seriesStatus: boolean = false;
  resoursesCount: number = 0;
  haveApiError: boolean = false;
  previousUrl: string;
  queryString: any;
  previousUrlTxt: string;
  cacheKey: any;
  listId: any;
  calltype: any;
  responseAPIstatus: boolean = true;
  onNext: boolean = true;
  resourceDetail: any = [];
  sectionsData: any[];
  reviewTab: any[];
  authorTab: any[] = [];
  googlePreviewTab: any[] = [];
  contentTab: any[] = [];
  profileTab: any[] = [];
  suggesionTab: any[] = [];
  seriesData: any[] = [];
  avaibiltyData: any[] = [];
  honorTab: any[] = [];
  librarySetting: any = [];
  shelfData: any[];
  excerptTableft: string;
  excerptTabRight: string;
  onTabs: boolean = true;
  showShefcar: boolean = false;
  slideConfig: object;
  isbnId: any = "";
  alsoCheckedOut: boolean = false;
  isSeries: boolean = false;
  userCanReview: boolean = false;
  showShelfStatus: boolean = false;
  player: any;
  slideConfigSuggestion: any;
  slideConfigSlider: any;
  facets: string = "";
  selectedResourcesIds: any = [];

  awardsId: number;
  awardsYear: number;
  awardsName: string;
  reviewCategories: any = [];
  patronId: any = null;
  patronName: string = "";
  showAddFormStatus: boolean = false;
  isWriteReview: boolean = false;
  isLogin: boolean = false;
  showHoldDate: boolean = false;
  isPatronReview: boolean = false;
  date: any = new Date(Date.now());
  currentLibrary: string = "";
  lastDayDate: any = "";
  dateFormat: string = "M/d/yyyy";
  videoIds = "";
  ngOnInit() {
    this.loadYouTubeAPI();
    var dd = new Date(Date.now());
    this.dateFormat = this.homepageService.formatDate();
    this.lastDayDate = dd.setDate(dd.getDate() - 1);
    this.previousUrl = this.routerService.getPreviousUrl();
    if (
      this.previousUrl != "" &&
      typeof this.previousUrl != "undefined" &&
      this.previousUrl != "/"
    ) {
      this.urlDecoder(this.previousUrl);
    }
    this.route.queryParams.subscribe((params) => {
      this.facets = params.facets;
      if (typeof params.year != "undefined") {
        this.awardsYear = params.year;
      }
      if (typeof params.awardid != "undefined") {
        this.awardsId = params.awardid;
      }
      if (typeof params.awardname != "undefined") {
        this.awardsName = params.awardname;
      }
    });
    if (this.cookieService.get("highlightParameter")) {
      this.highlightParameter = JSON.parse(
        this.cookieService.get("highlightParameter")
      );
    }

    if (this.cookieService.check("patronPermissions")) {
      var permissions = JSON.parse(this.cookieService.get("patronPermissions"));
      this.isWriteReview = permissions.opacWriteReview;
      this.isLogin = true;
    }

    this.previousUrlTxt = this.routerService.getTextUrl();
    this.document.body.classList.add("inner-page");
    this.document.body.classList.remove("list");
    this.calltype = this.route.snapshot.paramMap.get("calltype");
    this.cacheKey = this.route.snapshot.paramMap.get("chacheKey");
    this.listId = this.route.snapshot.paramMap.get("listId");
    this.librarySetting = this.homepageService.getUpdatedConfig();
    if (this.cookieService.check("userDetail")) {
      var detail = JSON.parse(this.cookieService.get("userDetail"));
      this.patronId = detail.patronId;
      this.patronName = detail.firstName + " " + detail.lastName;
    }
    var tnt = this.librarySetting.data.tenantCode.toLowerCase();
    var slctloc = this.cookieService.get("selectedlocation" + tnt);
    this.librarySetting.data.settings.location.locations.forEach((loc) => {
      if (loc.id == slctloc) {
        this.currentLibrary = loc.name;
      }
    });

    /******************* Get Review categories **************/

    this.homepageService.getReviewCategories().subscribe((data) => {
      this.reviewCategories = data;
    });

    /******************* Get Review categories **************/

    //These are the slider's configurations for different sliders.
    this.slideConfig = {
      slidesToShow: 7,
      initialSlide: 0,
      slidesToScroll: 7,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 6000,
      cssEase: "linear",
      dots: true,
      vertical: false,
      prevArrow:
        '<button class="slickArrowpre slick-arrow" aria-label="Previous" type="button" style=""><i class="fas fa-chevron-left"></i></button>',
      nextArrow:
        '<button class="slickArrownxt slick-arrow" aria-label="Previous" type="button" style=""><i class="fas fa-chevron-right"></i></button>',
      responsive: [
        { breakpoint: 1281, settings: { slidesToShow: 5, slidesToScroll: 5 } },
        { breakpoint: 1199, settings: { slidesToShow: 5, slidesToScroll: 5 } },
        { breakpoint: 992, settings: { slidesToShow: 3, slidesToScroll: 3 } },
        { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      ],
    };

    this.slideConfigSlider = {
      slidesToShow: 9,
      initialSlide: 0,
      slidesToScroll: 1,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 6000,
      cssEase: "linear",
      dots: true,
      vertical: false,
      prevArrow:
        '<button class="slickArrowpre slick-arrow" aria-label="Previous" type="button" style=""><i class="fas fa-chevron-left"></i></button>',
      nextArrow:
        '<button class="slickArrownxt slick-arrow" aria-label="Previous" type="button" style=""><i class="fas fa-chevron-right"></i></button>',
      responsive: [
        { breakpoint: 1281, settings: { slidesToShow: 7, slidesToScroll: 7 } },
        { breakpoint: 1199, settings: { slidesToShow: 7, slidesToScroll: 7 } },
        { breakpoint: 992, settings: { slidesToShow: 5, slidesToScroll: 5 } },
        { breakpoint: 768, settings: { slidesToShow: 3, slidesToScroll: 3 } },
        { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      ],
    };

    this.slideConfigSuggestion = {
      slidesToShow: 5,
      initialSlide: 0,
      slidesToScroll: 4,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 6000,
      cssEase: "linear",
      dots: true,
      vertical: false,
      prevArrow:
        '<button class="slickArrowpre slick-arrow" aria-label="Previous" type="button" style=""><i class="fas fa-chevron-left"></i></button>',
      nextArrow:
        '<button class="slickArrownxt slick-arrow" aria-label="Previous" type="button" style=""><i class="fas fa-chevron-right"></i></button>',
      responsive: [
        { breakpoint: 1281, settings: { slidesToShow: 5, slidesToScroll: 5 } },
        { breakpoint: 1199, settings: { slidesToShow: 3, slidesToScroll: 3 } },
        { breakpoint: 992, settings: { slidesToShow: 3, slidesToScroll: 3 } },
        { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 575, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      ],
    };

    if (localStorage.getItem("selectedResourcesIds") != null) {
      this.selectedResourcesIds = JSON.parse(
        localStorage.getItem("selectedResourcesIds")
      );
    }
  }

  //Date picker options.
  options: DatepickerOptions = {
    minYear: 1970,
    maxYear: 2030,
    format: "MM-dd-yyyy",
    formatTitle: "MMMM yyyy",
    formatDays: "EEEEEE",
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
    minDate: this.lastDayDate, // Minimal selectable date
    //barTitleIfEmpty: 'Desired Date',
    //calendarClass: 'datepicker-blue',
    //scrollBarColor: '#ffffff',
    inputClass: "holdDesireDate",
    placeholder: "Select Date", // HTML input placeholder attribute (default: '')
    //addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
    // fieldId: 'holdDesireDate', // ID to assign to the input field. Defaults to datepicker-<counter>
    //useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown
  };

  //Decoding url.
  urlDecoder(url) {
    let parsedUrl = this.router.parseUrl(url);
    const g: UrlSegmentGroup = parsedUrl.root.children[PRIMARY_OUTLET];
    const s: UrlSegment[] = g.segments;
    this.previousUrl = `${s.map((p) => p.path).join("/")}`;
    this.queryString = parsedUrl.queryParams;
  }

  //Loading details of book.
  loadDetail(cacheKey, listId) {
    this.showHoldDate = false;
    this.showAddFormStatus = false;
    $("#AvailabilityButton").removeClass("open");
    $("#AvailabilityTable").removeClass("open").hide();
    this.onNext = true;
    var sectionsDatatemp = [];
    var isbnIs;
    if (cacheKey == "single") {
      this.showShefcar = true;
      this.showShelfStatus = true;
      return this.homepageService.getResourceDetailById(listId).subscribe(
        (data: any) => {
          if (data.status !== true) {
            this.responseAPIstatus = false;
            this.haveApiError = true;
            var router = this.router;
            setTimeout(function () {
              router.navigate(["/"]);
            }, 10000);
          }

          //checking patron logged in or not.
          this.isPatronReview = false;
          if (
            this.cookieService.check("userDetail") &&
            this.librarySetting.data.settings.reviews.enabled
          ) {
            this.isReviewedByPatron(data.data.resourceId);
          } else if (
            this.librarySetting.data.settings.reviews.loginRequired &&
            this.librarySetting.data.settings.reviews.enabled
          ) {
            this.isPatronReview = true;
          }

          var defaultPos = 50;
          var isVideo = 0;
          this.videoIds = "";
          var $this = this;
          $.each(data.data.sections, function (key, value) {
            if (value.show == true) {
              if (key == "fields") {
                key = "detail";
                $this.hasDetailTab = true;
              }
              if (key == "video") {
                isVideo = 1;
                $this.videoIds = value.content[0].videoInfo.id;
              }
              value["tab"] = key;
              if (typeof sectionsDatatemp[value.position] != "undefined") {
                sectionsDatatemp[defaultPos] = value;
                defaultPos++;
              } else {
                sectionsDatatemp[value.position] = value;
              }
            }
          });

          //Getting details of avaiability.
          this.homepageService
            .getAvailableDetail(
              data.data.resourceId,
              data.data.category.id,
              data.data.call
            )
            .subscribe((dataA: any) => {
              this.avaibiltyData = dataA.data;
              googleApiCall();
            });
          this.isbnId = isbnIs;
          var setmp = [];
          sectionsDatatemp.forEach((ent) => {
            setmp.push(ent);
          });

          this.sectionsData = [];
          if (typeof this.tabModal != "undefined") {
            this.tabModal.unslick();
          }
          this.sectionsData = sectionsDatatemp;
          //console.log(this.sectionsData);
          $(".temp.Placeholders").remove();
          var IdR = this.resourceDetail.resourceId;
          $("button.MyListButton").removeClass("hide").removeClass("show");
          if (this.selectedResourcesIds.indexOf(IdR) >= 0) {
            $("button.addButton" + IdR)
              .addClass("hide")
              .removeClass("show");
            $("button.removeButton" + IdR)
              .removeClass("hide")
              .addClass("show");
          } else {
            $("button.addButton" + IdR)
              .addClass("show")
              .removeClass("hide");
            $("button.removeButton" + IdR)
              .removeClass("show")
              .addClass("hide");
          }
          this.resourceDetail = data.data;
          if(this.resourceDetail.sections && this.resourceDetail.sections.marc && this.resourceDetail.sections.marc.content){
            this.resourceDetail.sections.marc.content.forEach((tabs) => {
              if (tabs.tag == "300") {
                tabs.subfields.forEach((cod) => {
                  if (cod.code == "a") {
                    this.resourceDetail.physicalDesc = cod.value;
                  }
                });
              }
            });
          }
          this.responseAPIstatus = false;
          this.onNext = false;
          this.onTabs = false;

          this.showShefcar = false;
          this.showShelfStatus = false;
          if (typeof this.galleryOne != "undefined") {
            this.galleryOne.unslick();
          }

          if ($("section.bread-crumbs").length > 0) {
            $("html, body")
              .stop()
              .animate(
                { scrollTop: $("section.bread-crumbs").offset().top },
                1000,
                "swing",
                function () {}
              );
          }

          $("button.MyListButton").removeClass("hide").removeClass("show");
          if (isVideo == 1) {
            this.initializeYouTubePlayer();
          }
        },
        (err) => {
          if (err.error.Status !== true) {
            this.responseAPIstatus = false;
            this.haveApiError = true;
            var router = this.router;
            setTimeout(function () {
              router.navigate(["/"]);
            }, 10000);
          }
        }
      );
    } else {
      this.showShefcar = false;
      if (typeof this.galleryOne != "undefined") {
        this.galleryOne.unslick();
      }

      this.shelfData = [];
      this.showShelfStatus = false;
      var auth: any = null;
      //if(this.cookieService.check( 'info')){
      if (localStorage.getItem("info")) {
        var auth: any = localStorage.getItem("token");
      }
      this.homepageService
        .getMainResourceDetail(
          cacheKey,
          listId,
          "date",
          true,
          false,
          this.facets,
          auth
        )
        .subscribe(
          (data: any) => {
            if (data.status !== true) {
              this.responseAPIstatus = false;
              this.haveApiError = true;
              var router = this.router;
              setTimeout(function () {
                router.navigate(["/"]);
              }, 10000);
            }
            this.isPatronReview = false;
            if (
              this.cookieService.check("userDetail") &&
              this.librarySetting.data.settings.reviews.enabled
            ) {
              this.isReviewedByPatron(data.data.resourceId);
            } else if (
              this.librarySetting.data.settings.reviews.loginRequired &&
              this.librarySetting.data.settings.reviews.enabled
            ) {
              this.isPatronReview = true;
            }
            var defaultPos = 50;
            var isVideo = 0;
            this.videoIds = "";
            var $this = this;
            $.each(data.data.sections, function (key, value) {
              if (value.show == true) {
                //console.log(key);
                if (key == "fields") {
                  key = "detail";
                  $this.hasDetailTab = true;
                }
                if (key == "video") {
                  isVideo = 1;
                  $this.videoIds = value.content[0].videoInfo.id;
                }
                value["tab"] = key;
                if (typeof sectionsDatatemp[value.position] != "undefined") {
                  sectionsDatatemp[defaultPos] = value;
                  defaultPos++;
                } else {
                  sectionsDatatemp[value.position] = value;
                }
              }
            });

            this.homepageService
              .getAvailableDetail(
                data.data.resourceId,
                data.data.category.id,
                data.data.call
              )
              .subscribe((dataA: any) => {
                this.avaibiltyData = dataA.data;
                googleApiCall();
              });
            this.isbnId = isbnIs;
            //console.log(sectionsDatatemp);
            sectionsDatatemp.sort();
            var setmp = [];
            sectionsDatatemp.forEach((ent) => {
              setmp.push(ent);
            });

            this.sectionsData = [];
            if (typeof this.tabModal != "undefined") {
              this.tabModal.unslick();
            }
            this.sectionsData = sectionsDatatemp;
            //console.log(this.sectionsData);
            $(".temp.Placeholders").remove();

            this.resourceDetail = data.data;
            if(this.resourceDetail.sections && this.resourceDetail.sections.marc && this.resourceDetail.sections.marc.content){
              this.resourceDetail.sections.marc.content.forEach((tabs) => {
                if (tabs.tag == "300") {
                  tabs.subfields.forEach((cod) => {
                    if (cod.code == "a") {
                      this.resourceDetail.physicalDesc = cod.value;
                    }
                  });
                }
              });
            }
            var IdR = this.resourceDetail.resourceId;
            $("button.MyListButton").removeClass("hide").removeClass("show");
            if (this.selectedResourcesIds.indexOf(IdR) >= 0) {
              $("button.addButton" + IdR)
                .addClass("hide")
                .removeClass("show");
              $("button.removeButton" + IdR)
                .removeClass("hide")
                .addClass("show");
            } else {
              $("button.addButton" + IdR)
                .addClass("show")
                .removeClass("hide");
              $("button.removeButton" + IdR)
                .removeClass("show")
                .addClass("hide");
            }

            this.responseAPIstatus = false;
            this.onNext = false;
            this.onTabs = false;
            //checking for video
            if (isVideo == 1) {
              this.initializeYouTubePlayer();
            }
          },
          (err) => {
            if (err.error.Status !== true) {
              this.responseAPIstatus = false;
              this.haveApiError = true;
              var router = this.router;
              setTimeout(function () {
                router.navigate(["/"]);
              }, 10000);
            }
          }
        );
    }
  }

  //Showing icon on image error.
  imageError(event, images) {
    if (
      typeof $("body")
        .find('img[custom="' + event + '"]')
        .attr("index") != "undefined" &&
      parseInt(
        $("body")
          .find('img[custom="' + event + '"]')
          .attr("index")
      ) > 0
    ) {
      var index: number = parseInt(
        $("body")
          .find('img[custom="' + event + '"]')
          .attr("index")
      );
      if (
        typeof $("body")
          .find('img[custom="' + event + '"]')
          .attr("loaded") != "undefined"
      )
        index--;
      if (event == "tabAuthors")
        //console.log($('body').find('img[custom="'+event+'"]').attr('index'), 'tabAuthor');
        this.imageLoad(event, images, index, true);
    } else {
      if (
        $("body")
          .find('img[custom="' + event + '"]')
          .attr("alt") != ""
      ) {
        $("body")
          .find('img[custom="' + event + '"]')
          .after(
            '<span class="Placeholders ' +
              $("body")
                .find('img[custom="' + event + '"]')
                .attr("name") +
              '"><i class="material-icons md-48">' +
              $("body")
                .find('img[custom="' + event + '"]')
                .attr("alt") +
              "</i></span>"
          );
      }
      $("body")
        .find('img[custom="' + event + '"]')
        .remove();
    }
    /*$('body').find('img[custom="'+event+'"]').after('<span class="temp Placeholders '+$('body').find('img[custom="'+event+'"]').attr('name')+'"><i class="material-icons md-48">'+$('body').find('img[custom="'+event+'"]').attr('alt')+'</i></span>');
      $('body').find('img[custom="'+event+'"]').hide().attr('loaded','');
      */
  }

  //Loading best fit image to main resource.
  imageLoad(event, images, index, fromError = false) {
    /*//$('body').find('img[custom="'+event+'"]').show();
      if($('body').find('img[custom="'+event+'"]').attr('loaded') == 'yes') {
        $('body').find('img[custom="'+event+'"]').removeAttr('loaded');
        return false;
      }
      var sizes = ['xl','l','m','s','xs','xxs'];     
      var imagesAll = [];
      sizes.forEach((evt) => {
        images.forEach((img) => {
          if(img.size == evt){
            imagesAll.push(img.url);
          }
        });      
      });    
    //console.log(imagesAll);
    if(event == 'tabAuthors' && typeof(imagesAll[0]) != 'undefined'){
        $('body').find('img[custom="'+event+'"]').attr('src',imagesAll[0]).removeAttr('style');
        //getImageWidth(imagesAll[0], 'tabAuthors');
    }  else {
      setTimeout(function() {
        if(typeof(imagesAll[0]) != 'undefined') {
          $('#TempImg').attr('src',imagesAll[0]);
          $('body').find('img[custom="'+event+'"]').attr('src',imagesAll[0]);
          $('body').find('img[custom="'+event+'"]').attr('loaded','yes');                
        }
        //console.log(imagesAll, imagesAll[0], 'Final Image');
      },10);
    }*/
    $("body")
      .find('img[custom="' + event + '"]')
      .show();
    if (
      $("body")
        .find('img[custom="' + event + '"]')
        .attr("loaded") == "yes" &&
      !fromError
    ) {
      return false;
    }
    if ($("body").find("#" + event).length <= 0) {
      $("body").append('<img id="' + event + '" src="" style="display:none;">');
    }
    var $this = this;
    var imagesAll = this.searchService.sortedImage(images);
    $("#" + event).attr("src", imagesAll[index]);
    setTimeout(function () {
      var tempWidth = $("#" + event).width();
      var temp = document.getElementById(event);
      if (tempWidth <= 1 && index > 0) {
        $this.imageLoad(event, images, index - 1, true);
        return false;
      } else if (tempWidth <= 1 && index == 0) {
        $("body")
          .find('img[custom="' + event + '"]')
          .after(
            '<span class="Placeholders ' +
              $("body")
                .find('img[custom="' + event + '"]')
                .attr("name") +
              '"><i class="material-icons md-48">' +
              $("body")
                .find('img[custom="' + event + '"]')
                .attr("alt") +
              "</i></span>"
          );
        $("body")
          .find('img[custom="' + event + '"]')
          .remove();
      }
    }, 100);
    if (typeof imagesAll[index] != "undefined") {
      $("body")
        .find('img[custom="' + event + '"]')
        .attr("src", imagesAll[index]);
      $("body")
        .find('img[custom="' + event + '"]')
        .attr("loaded", "yes");
      $("body")
        .find('img[custom="' + event + '"]')
        .attr("index", index);
    }
  }

  //Loading best fit image to series.
  imageLoadSeries(event, images) {
    $("body")
      .find('img[custom="' + event + '"]')
      .show();
    if (
      $("body")
        .find('img[custom="' + event + '"]')
        .attr("loaded") == "yes"
    ) {
      $("body")
        .find('img[custom="' + event + '"]')
        .removeAttr("loaded");
      return false;
    }
    var sizes = ["xl", "l", "m", "s", "xs", "xxs"];
    var imagesAll = [];
    sizes.forEach((evt) => {
      images.forEach((img) => {
        if (img.sizeAsString == evt) {
          imagesAll.push(img.url);
        }
      });
    });
    setTimeout(function () {
      if (typeof imagesAll[0] != "undefined") {
        $("#TempImg").attr("src", imagesAll[0]);
        $("body")
          .find('img[custom="' + event + '"]')
          .attr("src", imagesAll[0]);
        $("body")
          .find('img[custom="' + event + '"]')
          .attr("loaded", "yes");
      }
    }, 10);
  }

  //Loading detail tab content.
  dynamicLoad(url, tab) {
    //console.log(url,tab);
    this.seriesStatus = false;
    setTimeout(function () {
      $("ul#pills-tab").find("a").removeClass("active").removeClass("show");
      $("#pills-noveList-tab").find("a").addClass("active show");
      $("li." + tab + "TabTop")
        .find("a")
        .addClass("active")
        .addClass("show");
    }, 200);
    this.isSeries = false;
    this.alsoCheckedOut = false;
    this.onTabs = true;
    if (
      typeof url != "undefined" &&
      url != null &&
      url.trim() != "" &&
      tab != "awards"
    ) {
      return this.homepageService.dynamicLoadAPI(url).subscribe((data: any) => {
        //console.log('Test dynamic load');
        this.onTabs = false;
        if (tab == "reviews") {
          this.reviewTab = data.data;
        }
        if (tab == "excerpt") {
          var total = data.data.split(" ").length;
          var cnt = parseInt(total) / 2;
          this.excerptTableft = data.data.split(" ").splice(0, cnt).join(" ");
          this.excerptTabRight = data.data
            .split(" ")
            .splice(cnt, total)
            .join(" ");
        }
        if (tab == "author") {
          this.authorTab = data.data;
        }
        if (tab == "series") {
          this.seriesData = data.data;
          this.seriesStatus = true;
        }
        if (tab == "contents") {
          this.contentTab = data.data;
        }
        if (tab == "profile") {
          this.profileTab = data.data;
        }
        if (tab == "suggestions") {
          this.suggesionTab = data.data;
          if (data.data.alsoCheckedOut.length > 0) {
            this.alsoCheckedOut = true;
          }
          if (data.data.inSeries.length > 0) {
            this.isSeries = true;
          }
        }
      });
    } else {
      this.onTabs = false;
    }
    if (tab == "video") {
      this.initializeYouTubePlayer();
    }
  }

  loadYouTubeAPI(): void {
    const doc = (<any>window).document;
    if (!doc.getElementById("youtube-api-script")) {
      const playerApiScript = doc.createElement("script");
      playerApiScript.type = "text/javascript";
      playerApiScript.src = "https://www.youtube.com/iframe_api";
      doc.body.appendChild(playerApiScript);
    }
    (<any>window).onYouTubeIframeAPIReady = () => {
      this.initializeYouTubePlayer();
    };
  }
  initializeYouTubePlayer(): void {
    const playerElement = this.document.getElementById("ytPlayer");
    if (playerElement) {
      this.player = new (<any>window).YT.Player("ytPlayer", {
        height: "600px",
        width: "100%",
        videoId: this.videoIds,
        playerVars: { autoplay: 0, rel: 0, controls: 0 },
        events: {
          onReady: (event) => {},
          onStateChange: (event) => {},
        },
      });
    }
  }

  //Need to work on that. After API update.
  slickInit(e) {
    if (!this.hasDetailTab) {
      var $this = this;
      setTimeout(function () {
        if (
          $("section.book-detail-tab")
            .find(".slick-list")
            .find("li.nav-item:first")
            .hasClass("googlePreviewTabTop")
        ) {
          $("section.book-detail-tab")
            .find(".slick-list")
            .find("li.nav-item:nth-child(2)")
            .find("a:first")
            .addClass("active")
            .trigger("click");
          let tempData = $("section.book-detail-tab")
            .find(".slick-list")
            .find("li.nav-item:nth-child(2)")
            .find("a:first")
            .attr("id");
          let tempTab = tempData.split(",");
          $this.dynamicLoad(tempTab[0], tempTab[1]);
        } else {
          $("section.book-detail-tab")
            .find(".slick-list")
            .find("li.nav-item:first")
            .find("a:first")
            .addClass("active")
            .trigger("click");
          let tempData = $("section.book-detail-tab")
            .find(".slick-list")
            .find("li.nav-item:first")
            .find("a:first")
            .attr("id");
          let tempTab = tempData.split(",");
          $this.dynamicLoad(tempTab[0], tempTab[1]);
        }
      }, 500);
    }
  }

  //Showing book shelf.
  showShelf() {
    //this.slideConfig.slidesToShow =6;
    this.shelfData = [];
    $("html, body")
      .stop()
      .animate(
        { scrollTop: $("section.new-library").offset().top },
        1500,
        "swing",
        function () {}
      );
    this.showShefcar = true;
    this.showShelfStatus = true;
    //this.shelfData = [];
    var elmnt = <HTMLSelectElement>document.getElementById("showShefcar");
    //elmnt.scrollIntoView();

    this.homepageService
      .getResourceShelf(
        this.resourceDetail.resourceId,
        this.resourceDetail.category.id,
        this.resourceDetail.call
      )
      .subscribe((shel: any) => {
        if (typeof this.galleryOne != "undefined") {
          this.galleryOne.unslick();
        }
        this.shelfData = shel;
        var cnt = 0;
        shel.data.forEach((sld) => {
          if (sld.listItemId >= 0) {
          } else {
            cnt++;
          }
        });

        if ($(window).width() > 1280) {
          cnt = cnt - 3;
        } else if ($(window).width() > 991 && $(window).width() < 1280) {
          cnt = cnt - 2;
        } else if ($(window).width() > 768 && $(window).width() < 992) {
          cnt = cnt - 1;
        } else if ($(window).width() < 768) {
          cnt = cnt;
        }
        this.slideConfig["initialSlide"] = cnt;
        var self = this;
        this.showShefcar = false;
        setTimeout(function () {
          //self.galleryOne.slickGoTo(cnt);
          $(".shelfTabno0").addClass("openShelf");
        }, 1000);
      });
  }

  //Hiding book shelf.
  hideShelf() {
    if (typeof this.galleryOne != "undefined") {
      this.galleryOne.unslick();
    }
    this.showShelfStatus = false;
  }

  //Showing avaiability of book.
  AvailabilityShow(event) {
    $(event.target).toggleClass("open");
    $("#AvailabilityTable").toggleClass("open").slideToggle("slow");
  }

  //Resource added to my list.
  addToMyList(event, Id) {
    var self = this;
    $(".addButton" + Id).addClass("fadeOutUp");
    $("#myCollectionLi").addClass("fadeOutUpLI");
    setTimeout(function () {
      $(".addButton" + Id)
        .addClass("hide")
        .removeClass("show")
        .removeClass("fadeOutUp");
      $(".removeButton" + Id)
        .addClass("show")
        .removeClass("hide");
      this.resoursesCount = $(".addButton" + Id).length;
      var currentList = parseInt(
        $("#myCollectionLi").find("span.count").text()
      );
      self.cookieService.set("MyLIstCount", currentList + this.resoursesCount);
      $("#myCollectionLi")
        .find("span.count")
        .text(currentList + this.resoursesCount);
      $("#myCollectionLi")
        .find("a.onViewList")
        .removeClass("hide")
        .addClass("show");
      $("#Publish-My-List").removeClass("hide").addClass("show");
      if ($("#myCollectionLi").hasClass("hide")) {
        $("#myCollectionLi").removeClass("hide");
        $("#myCollectionLi").addClass("show");
      }
      var i: number;
      for (i = 1; i <= this.resoursesCount; i++) {
        self.selectedResourcesIds.push(Id);
      }
      localStorage.setItem(
        "selectedResourcesIds",
        JSON.stringify(self.selectedResourcesIds)
      );

      //if(self.cookieService.check( 'info')){
      if (localStorage.getItem("info") != null) {
        var auth = localStorage.getItem("token");
        self.homepageService
          .saveMyList(auth, self.selectedResourcesIds)
          .subscribe(
            (data) => {},
            (error) => {
              if (self.cookieService.check("tempPersonalCollection")) {
                var cacheKey = self.cookieService.get("tempPersonalCollection");
              } else {
                var cacheKey = "";
              }
              var itemIds: any = [];
              itemIds.push(Id);
              self.homepageService
                .personalcollection(itemIds, cacheKey)
                .subscribe((data) => {
                  if (data.status) {
                    self.cookieService.set(
                      "tempPersonalCollection",
                      data.data.cacheKey,
                      365,
                      "/"
                    );
                  }
                });
            }
          );
      } else {
        if (self.cookieService.check("tempPersonalCollection")) {
          var cacheKey = self.cookieService.get("tempPersonalCollection");
        } else {
          var cacheKey = "";
        }
        var itemIds: any = [];
        itemIds.push(Id);
        self.homepageService
          .personalcollection(itemIds, cacheKey)
          .subscribe((data) => {
            if (data.status) {
              self.cookieService.set(
                "tempPersonalCollection",
                data.data.cacheKey,
                365,
                "/"
              );
            }
          });
      }
    }, 1000);
    setTimeout(function () {
      $("#myCollectionLi").removeClass("fadeOutUpLI");
    }, 5000);
  }

  //Removing title from my list.
  removeToMyList(event, Id) {
    $(document)
      .find(".addButton" + Id)
      .addClass("show")
      .removeClass("hide");
    $(document)
      .find(".removeButton" + Id)
      .addClass("hide")
      .removeClass("show");
    this.resoursesCount = $(".removeButton" + Id).length;
    var i: number;
    for (i = 1; i <= this.resoursesCount; i++) {
      var index = this.selectedResourcesIds.indexOf(Id);
      if (index > -1) {
        var index = this.selectedResourcesIds.splice(index, 1);
      }
    }
    localStorage.setItem(
      "selectedResourcesIds",
      JSON.stringify(this.selectedResourcesIds)
    );
    var currentList = parseInt($("#myCollectionLi").find("span.count").text());
    $("#myCollectionLi")
      .find("span.count")
      .text(currentList - this.resoursesCount);
    var tempCurrentList = currentList - this.resoursesCount;
    this.cookieService.set("MyLIstCount", tempCurrentList.toString());
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info")) {
      var auth = localStorage.getItem("token");
      this.homepageService.removeMyList(auth, Id).subscribe((data) => {});
    } else {
      if (this.cookieService.check("tempPersonalCollection")) {
        var cacheKey = this.cookieService.get("tempPersonalCollection");
        this.homepageService
          .removePersonalcollection(Id, cacheKey)
          .subscribe((data) => {});
      }
    }
  }

  //Action on star rating change.
  onRatingChange(event) {
    $("#reviewStar").val(event.rating);
    //console.log($('#reviewStar').val(event.rating));
    $(document).find(".messageReview.error").remove();
  }

  //Save review.
  saveReview() {
    var error = 0;
    let resourceId: any = parseInt($("#resourceid").val().toString());
    let patronId: any = parseInt($("#patronId").val().toString());
    var title = $("#reviewTitle").val();
    var author = $("#reviewAuthor").val();
    let ratingStar: any = 0;
    var reviewText = $("#reviewText").val();
    if (this.librarySetting.data.settings.ratings.enabled) {
      ratingStar = parseFloat($("#reviewStar").val().toString());
      if (ratingStar == 0) {
        $("#reviewStar")
          .parent()
          .append(
            '<span class="messageReview error">Please give rating</span>'
          );
        setTimeout(function () {
          $(document).find(".messageReview").remove();
        }, 5000);
        error++;
      }
    }
    if ($.trim(reviewText.toString()) == "") {
      $("#reviewText").addClass("error");
      setTimeout(function () {
        $(document).find("#reviewText").removeClass("error");
      }, 5000);
      error++;
    }
    var reviewer = $("#reviewerName").val();
    if ($.trim(reviewer.toString()) == "") {
      $("#reviewerName").addClass("error");
      error++;
    }

    var categories = [];
    if (
      $(".reviewCategory").find('input[type="checkbox"]:checked').length > 0
    ) {
      $(".reviewCategory")
        .find('input[type="checkbox"]:checked')
        .each(function () {
          categories.push(parseInt($(this).val().toString()));
        });
    } else {
      if ($(".reviewCategory").find(".reviewCatError").length == 0) {
        $(".reviewCategory")
          .find(".clearfix")
          .after(
            '<span class="reviewCatError" style="text-align:left; padding-left:15px;">Select at least one category</span>'
          );
      }
      setTimeout(function () {
        $(document).find(".reviewCatError").remove();
      }, 5000);
      error++;
    }

    if (error != 0) {
      return false;
    }
    this.saveReviewStatus = true;
    this.isPatronReview = true;
    var auth = "";
    //if(this.cookieService.check( 'info'))
    if (localStorage.getItem("info")) auth = localStorage.getItem("token");
    this.homepageService
      .addReview(
        resourceId,
        patronId,
        title,
        author,
        ratingStar,
        reviewText,
        reviewer,
        categories,
        auth
      )
      .subscribe(
        (data) => {
          if (this.librarySetting.data.settings.ratings.enabled) {
            this.resourceDetail.ratings.stars = ratingStar;
            var count = parseInt($(".star-count").text()) + 1;
            $(".star-count").text(count);
          }
          $("#reviewText").val("");
          $("#reviewTitle").val("");
          $(".reviewCategory")
            .find('input[type="checkbox"]:checked')
            .prop("checked", false);
          this.notifier.notify(
            "success",
            "The review has been submitted for publication"
          );
          $("#closereviewAdd").trigger("click");
          this.saveReviewStatus = false;
        },
        (err) => {
          if (err.status == 400) {
            this.saveReviewStatus = false;
            this.notifier.notify("error", err.error.message);
            $("#closereviewAdd").trigger("click");
          }
        }
      );
  }

  //Seeking for click event.
  onClickReview(event) {
    //console.log(event);
  }

  //showing add form.
  showAddForm() {
    this.showAddFormStatus = true;
  }

  //Showing add form for hold.
  showAddFormHold() {
    //if(!this.cookieService.check('info')){
    if (!localStorage.getItem("info")) {
      $("#loginSpanMessage").remove();
      document.getElementById("loginLia").click();
      $("#loginError").after(
        '<span id="loginSpanMessage">Log in to place a hold on this resource.</span>'
      );
      setTimeout(function () {
        $("#loginSpanMessage").remove();
      }, 10000);
    } else {
      this.showAddFormStatusHold = true;
    }
  }

  //Hide adding form
  hideAddForm() {
    this.showAddFormStatus = false;
    this.showAddFormStatusHold = false;
  }

  //Checking if resource is review or not.
  isReviewedByPatron(id) {
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info")) {
      var token = localStorage.getItem("token");
      this.homepageService
        .isReviewedByPatron(token, id)
        .subscribe((data: any) => {
          if (data.status) {
            this.isPatronReview = data.data.isReviewed;
          }
        });
    }
  }

  //Just checking review status by opening the modal.
  checkReviewStatus(event, id) {
    event.preventDefault();
    this.showReviewModal = true;
  }

  //close review box
  closeReviewStatus() {
    this.showReviewModal = false;
  }

  //To rate title.
  starRatingTitle(event, resourceId) {
    // console.log(event);
    if (typeof event.rating == "number") {
      var patronId: any = null;
      var token = localStorage.getItem("token");
      if (this.cookieService.check("userDetail")) {
        var detail = JSON.parse(this.cookieService.get("userDetail"));
        var patronId: any = detail.patronId;
      } else if (this.librarySetting.data.settings.ratings.loginRequired) {
        this.notifier.notify("warning", "You need to login to rate resources");
        return false;
      }
      this.showReviewModal = false;
      this.homepageService
        .addStarRating(resourceId, event.rating, patronId, token)
        .subscribe(
          (data: any) => {
            if (data.status) {
              this.resourceDetail.ratings.stars = event.rating;
              if (this.cookieService.check("userDetail")) {
                this.isPatronReview = true;
              }
              var count = parseInt($(".star-count").text()) + 1;
              $(".star-count").text(count);
              this.notifier.notify(
                "success",
                "Rating has been updated successfully"
              );
            } else {
              this.notifier.notify("error", data.message);
            }
          },
          (err) => {
            this.notifier.notify("error", "Something went wrong.Try again.");
          }
        );
    }
  }

  //Cancel hold request
  cancelHold(event, holdId) {
    var token = localStorage.getItem("token");
    this.resourceDetail.holdId = null;
    $("#cancelholdsClose").trigger("click");
    this.homepageService.cancelHoldAccount(holdId, token).subscribe(
      (data: any) => {
        if (data.status) {
          this.notifier.notify("success", data.message + " successfully");
          this.resourceDetail.canHold = true;
        } else {
          this.resourceDetail.holdId = holdId;
          this.resourceDetail.canHold = false;
          this.notifier.notify("error", data.message);
        }
      },
      (err) => {
        this.notifier.notify("error", "Something Went Wrong");
      }
    );
  }

  //Holding request
  holdResource(event, resourceId) {
    $(event.target).val("Wait...").attr("disabled", "disabled");
    var desiredDate = null;
    if (this.showHoldDate) {
      desiredDate = $(".holdDesireDate").val();
    }
    var auth = localStorage.getItem("token");
    var sessionId: any = 0;
    if (this.cookieService.check("renewSession")) {
      var sessionId: any = this.cookieService.get("renewSession");
    }
    this.homepageService
      .holdResource(sessionId, resourceId, desiredDate, auth)
      .subscribe(
        (data: any) => {
          if (data.status) {
            this.resourceDetail.holdId = data.data.circHoldId;
            this.resourceDetail.canHold = false;
            this.cookieService.set(
              "renewSession",
              data.data.sessionId,
              365,
              "/"
            );
            this.notifier.notify("success", data.message);
          } else {
            this.notifier.notify("error", data.message);
          }
          $(event.target).val("Hold").removeAttr("disabled");
          $("#closeHoldAdd").click();
          this.showHoldDate = false;
          this.date = new Date(Date.now());
        },
        (err) => {
          this.homepageService
            .holdResource(sessionId, resourceId, desiredDate, auth)
            .subscribe(
              (data: any) => {},
              (error) => {
                this.homepageService
                  .holdResource(
                    sessionId,
                    resourceId,
                    desiredDate,
                    localStorage.getItem("token")
                  )
                  .subscribe(
                    (data: any) => {
                      if (data.status) {
                        this.resourceDetail.holdId = data.data.circHoldId;
                        this.resourceDetail.canHold = false;
                        this.cookieService.set(
                          "renewSession",
                          data.data.sessionId,
                          365,
                          "/"
                        );
                        this.notifier.notify("success", data.message);
                      } else {
                        this.notifier.notify("error", data.message);
                      }
                      $(event.target).val("Hold").removeAttr("disabled");
                      $("#closeHoldAdd").click();
                      this.showHoldDate = false;
                      this.date = new Date(Date.now());
                    },
                    (err) => {
                      $(event.target).val("Hold").removeAttr("disabled");
                      this.notifier.notify("error", "Something Went Wrong");
                    }
                  );
              }
            );
        }
      );
  }

  //Showing hold date.
  showHoldDateFn(event) {
    if ($(event.target).is(":checked")) {
      this.showHoldDate = true;
    } else {
      this.showHoldDate = false;
      this.date = new Date(Date.now());
    }
  }

  //Checking url (Only checking for '&amp' to convert to &. to fix migration error.)
  checkUrlLink(string) {
    var temp = string.replace(/&amp;/g, "&");
    return decodeURIComponent(temp);
  }

  //New functions to image load and image handling for main image.
  imageError1(event, images) {
    if (
      typeof $("body")
        .find('img[custom="' + event + '"]')
        .attr("index") != "undefined" &&
      parseInt(
        $("body")
          .find('img[custom="' + event + '"]')
          .attr("index")
      ) > 0
    ) {
      var index: number = parseInt(
        $("body")
          .find('img[custom="' + event + '"]')
          .attr("index")
      );
      if (
        typeof $("body")
          .find('img[custom="' + event + '"]')
          .attr("loaded") != "undefined"
      )
        index--;
      this.imageLoad1(event, images, index, true);
    } else {
      $("body")
        .find('img[custom="' + event + '"]')
        .after(
          '<span class="Placeholders ' +
            $("body")
              .find('img[custom="' + event + '"]')
              .attr("name") +
            '"><i class="material-icons md-48">' +
            $("body")
              .find('img[custom="' + event + '"]')
              .attr("alt") +
            "</i></span>"
        );
      $("body")
        .find('img[custom="' + event + '"]')
        .remove();
    }
  }

  imageLoad1(event, images, index, fromError = false) {
    if (
      $("body")
        .find('img[custom="' + event + '"]')
        .attr("loaded") == "yes" &&
      !fromError
    ) {
      return false;
    }
    if ($("body").find("#" + event).length <= 0) {
      $("body").append('<img id="' + event + '" src="" style="display:none;">');
    }
    var $this = this;
    var sources = ["OL", "GB", "MR", "PQ", "CM"];
    var sizes = ["xxs", "xs", "s", "xl", "l", "m"];
    //var sizes = ['xl','l','m','s','xs','xxs'];
    // var sizes = ['m','l','xl','s','xs','xxs'];

    var imagesAll = [];
    sizes.forEach((evt) => {
      sources.forEach((src) => {
        images.forEach((img) => {
          if (img.size == evt && img.source == src) {
            imagesAll.push(img.url);
          }
        });
      });
    });

    //var imagesAll = this.searchService.sortedImage(images);
    //console.log(imagesAll, event);
    $("#" + event).attr("src", imagesAll[index]);
    setTimeout(function () {
      var tempWidth = $("#" + event).width();
      var temp = document.getElementById(event);
      if (tempWidth <= 1 && index > 0) {
        var typeEvee = typeof images;
        $this.imageLoad1(event, images, index, true);
        return false;
      } else if (tempWidth <= 1 && index == 0) {
        $("body")
          .find('img[custom="' + event + '"]')
          .after(
            '<span class="Placeholders ' +
              $("body")
                .find('img[custom="' + event + '"]')
                .attr("name") +
              '"><i class="material-icons md-48">' +
              $("body")
                .find('img[custom="' + event + '"]')
                .attr("alt") +
              "</i></span>"
          );
        $("body")
          .find('img[custom="' + event + '"]')
          .remove();
      }
    }, 5000);
    if (typeof imagesAll[index] != "undefined") {
      $("body")
        .find('img[custom="' + event + '"]')
        .attr("src", imagesAll[index]);
      $("body")
        .find('img[custom="' + event + '"]')
        .attr("loaded", "yes");
      $("body")
        .find('img[custom="' + event + '"]')
        .attr("index", index);
    }
  }

  showShare(event) {
    $(".book-detail").find(".dropdown-menu").toggleClass("show");
  }

  copyPermalink() {
    const base = new URL("/", location.href).href;
    var copyText = $("#permalink_share").attr("href");
    //console.log(base+copyText +'-------'+ copyText.slice(1);
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val(base + copyText.slice(1)).select();
    document.execCommand("copy");
    $temp.remove();
    this.link = base + copyText.slice(1);
    this.linkCopied = true;
  }

  hideLinkModal() {
    this.linkCopied = false;
    this.showShare(null);
  }

  noveListCall(data) {
    //console.log(data);
  }
}
